<script setup lang="ts"></script>
<template>
	<div class="min-h-screen">
		<PortalHeader variant="primary" class="h-[60px] lg:h-20" />

		<main class="box-border size-full">
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSectionNavigation />
		</Container>
		<Container class="bg-primary py-0!">
			<PortalFooter />
		</Container>
	</div>
</template>
